import { Lightbulb, CheckCircle2, XCircle } from "lucide-react";

export const GmailPromotionsStrategies = () => {
  const strategies = [
    {
      title: "Focus on Engagement, Not Tab Placement",
      description: "Users who engage with emails in Promotions are often higher-intent buyers. A well-designed promotional email that gets opened beats a Primary email that gets ignored.",
      doList: [
        "Optimize subject lines for opens",
        "Segment your list for relevance",
        "Send when your audience is active",
        "A/B test content and timing"
      ],
      dontList: [
        "Obsess over tab placement",
        "Sacrifice design for Primary",
        "Use deceptive subject lines",
        "Ignore engagement metrics"
      ]
    },
    {
      title: "Use Simpler HTML When Appropriate",
      description: "For transactional or relationship emails, simple HTML or plain text increases Primary placement chances. Reserve complex designs for promotional campaigns.",
      doList: [
        "Use minimal CSS and simple layouts",
        "Limit images to 1-2 when possible",
        "Keep email width under 600px",
        "Use system fonts"
      ],
      dontList: [
        "Oversimplify marketing emails",
        "Remove all branding",
        "Use only plain text for everything",
        "Ignore mobile responsiveness"
      ]
    },
    {
      title: "Build Reply Relationships",
      description: "Gmail prioritizes senders that recipients reply to. Encourage two-way conversation and make it easy for subscribers to respond.",
      doList: [
        "Send from a real reply-to address",
        "Ask questions in your emails",
        "Respond to replies promptly",
        "Use personal sender names"
      ],
      dontList: [
        "Use no-reply@ addresses",
        "Ignore subscriber responses",
        "Only send broadcast emails",
        "Use generic sender names"
      ]
    }
  ];

  return (
    <section className="py-8 sm:py-10">
      <div className="mb-6 sm:mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-success/10 flex items-center justify-center">
            <Lightbulb className="w-5 h-5 text-success" />
          </div>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground">
            Evidence-Based Strategies
          </h2>
        </div>
        <p className="text-muted-foreground">
          What actually works based on research and industry data
        </p>
      </div>

      <div className="space-y-6">
        {strategies.map((strategy, index) => (
          <div key={index} className="bg-card border border-border rounded-xl p-5 sm:p-6">
            <h3 className="font-display text-lg font-semibold text-foreground mb-2">
              {strategy.title}
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              {strategy.description}
            </p>
            
            <div className="grid sm:grid-cols-2 gap-4">
              {/* Do */}
              <div className="bg-success/5 border border-success/20 rounded-lg p-4">
                <h4 className="font-semibold text-success text-sm mb-2 flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4" />
                  Do This
                </h4>
                <ul className="space-y-1.5">
                  {strategy.doList.map((item, i) => (
                    <li key={i} className="text-sm text-muted-foreground flex items-start gap-2">
                      <span className="text-success mt-1">•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Don't */}
              <div className="bg-destructive/5 border border-destructive/20 rounded-lg p-4">
                <h4 className="font-semibold text-destructive text-sm mb-2 flex items-center gap-2">
                  <XCircle className="w-4 h-4" />
                  Avoid This
                </h4>
                <ul className="space-y-1.5">
                  {strategy.dontList.map((item, i) => (
                    <li key={i} className="text-sm text-muted-foreground flex items-start gap-2">
                      <span className="text-destructive mt-1">•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
